import { Stack, Typography } from '@mui/material';
import styled from 'styled-components';

import {
  BaseColorKeys, NotifierColorKeys, SubjectColorKeys,
} from '../../theme';

const DateStack = styled(Stack)`
  user-select: none;
  padding-left: ${({ theme }) => theme.spacing(0.5)};
  padding-right: ${({ theme }) => theme.spacing(0.5)};
`;

type Colored = {
  $color?: BaseColorKeys | SubjectColorKeys | NotifierColorKeys;
};

const Month = styled(Typography)<Colored>`
  && {
    margin-bottom: ${({ theme }) => theme.spacing(-1)};
    color: ${({ theme, $color }) => ($color ? theme.palette[$color].main : theme.palette.text.primary)};
  }
`;

const Date = styled(Typography)<Colored>`
  && {
    font-weight: bold;
    text-align-last: justify;
    color: ${({ theme, $color }) => ($color ? theme.palette[$color].main : theme.palette.text.primary)};
  }
`;

const EventIconWrapper = styled.div<Colored>`
  color: ${({ theme, $color }) => ($color ? theme.palette[$color].main : theme.palette.text.primary)};
`;

export { EventIconWrapper, DateStack, Month, Date };
